import React from 'react';
import { AiChat } from '@/components/Layout/Menu/HeaderV2/AiChat';
import {
  merlinActions,
} from '@/redux/modules';
import { useDispatch, useSelector } from 'react-redux';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { AI_AGENTS_MERLIN_SITES_CHAT_ID } from '@/config/GrowthBook/constants';
import { useResize } from '../useResize';

const useAiChat = () => {
  const dispatch = useDispatch();

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width <= 960;

  const chatId = useFeatureValue(AI_AGENTS_MERLIN_SITES_CHAT_ID);

  const {
    renderInHouseChat,
    minimizedChat,
    visibleAiChat,
  } = useSelector(state => state.merlin);

  const cookieName = 'merlinUrl';

  const handleInitialInteraction = ({ fullScreen = false, generateThreadId = false } = {}) => {
    dispatch(merlinActions.setChatData({ cookieName, chatId, isIframeOpen: true }));
    dispatch(merlinActions.inhouse.renderInHouseChat(true));
    dispatch(merlinActions.inhouse.minimizeInHousechat(false));

    if (generateThreadId) {
      dispatch(merlinActions.inhouse.generateThreadId());
    }

    if (fullScreen) {
      dispatch(merlinActions.inhouse.toggleFullScreen());
    }
    setTimeout(() => {
      dispatch(merlinActions.inhouse.visibilityInHousechat(true));
    }, 100);
  };

  const handleOpenMarketingAgent = () => {
    handleInitialInteraction();

    !isMobile && dispatch(merlinActions.inhouse.toggleFullScreen());
    dispatch(merlinActions.inhouse.setMaiaAgent('marketing'));
  };

  const triggerExternalAudioBlob = (blob, fullScreen = true) => {
    if (blob) {
      dispatch(merlinActions.inhouse.setExternalAudioBlob(blob));
      const forwardFullScreen = fullScreen && !isMobile;
      handleInitialInteraction({ fullScreen: forwardFullScreen, generateThreadId: true });
    }
  };

  const triggerExternalMessage = ({ message, fullScreen = true }) => {
    if (message) {
      const messageTrimmed = message.trim();
      dispatch(merlinActions.inhouse.setExternalMessage(messageTrimmed));
      const clientMessage = {
        type: 'text',
        text: messageTrimmed,
        src: 'client',
      };
      dispatch(merlinActions.inhouse.setMessage(clientMessage));
      const forwardFullScreen = fullScreen && !isMobile;
      handleInitialInteraction({ fullScreen: forwardFullScreen, generateThreadId: true });
    }
  };

  const getAiChatProps = () => {
    const handleClose = () => {
      dispatch(merlinActions.inhouse.renderInHouseChat(false));
    };

    const handleToggleMinimize = (bool) => {
      dispatch(merlinActions.inhouse.minimizeInHousechat(bool));
    };

    const setVisibleAiChat = (bool) => {
      dispatch(merlinActions.inhouse.visibilityInHousechat(bool));
    };

    return {
      handleClose,
      minimizedChat,
      handleToggleMinimize,
      visibleAiChat,
      setVisibleAiChat,
      renderInHouseChat,
    };
  };

  const handleAiChatRender = () => (
    !!renderInHouseChat && (
      <AiChat {...getAiChatProps()} />
    )
  );

  const handleRenderFullScreenAiChat = () => (
    <AiChat {...getAiChatProps()} />
  );

  return {
    handleAiChatRender,
    handleInitialInteraction,
    handleRenderFullScreenAiChat,
    handleOpenMarketingAgent,
    triggerExternalAudioBlob,
    triggerExternalMessage,
  };
};

export default useAiChat;
